export default "__VITE_ASSET__21cf0730__"